import { useCallback, useEffect, useState } from 'react';
import { Client, useStompClient } from 'react-stomp-hooks';

import commonStore from '../store/CommonStore';
import userActivityStore from '../store/UserActivityStore';

const UPDATE_ONLINE_TIMEOUT = 2000;

export const useBackgroundTracker = (): void => {
  const stompClient = useStompClient();
  const [cachedStompClient, setCachedStompClient] = useState<Client>();

  useEffect(() => {
    if (stompClient?.active) {
      setCachedStompClient(stompClient);
    }
  }, [stompClient?.active]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!commonStore.backgroundMode) {
        userActivityStore.updateBackgroundStatus(false);
      }
    }, UPDATE_ONLINE_TIMEOUT);
    return () => clearTimeout(timeout);
  }, [commonStore.backgroundMode]);

  const enableBackgroundMode = (): void => {
    commonStore.enableBackgroundMode();
    void userActivityStore.updateBackgroundStatus(true);
    cachedStompClient?.deactivate();
  };

  const disableBackgroundMode = (): void => {
    if (commonStore.backgroundMode) {
      commonStore.clearAllTableData();
      void userActivityStore.updateBackgroundStatus(false);
      cachedStompClient?.activate();
    }
  };

  const handleTabVisibilityChange = useCallback((): void => {
    const hidden = document.hidden;
    if (hidden) {
      enableBackgroundMode();
    } else {
      disableBackgroundMode();
    }
  }, [cachedStompClient]);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleTabVisibilityChange);
    return () =>
      document.removeEventListener(
        'visibilitychange',
        handleTabVisibilityChange,
      );
  }, [cachedStompClient]);
};
